import { useState } from "react";
import QuestionBox from "../../ui/QuestionBox/QuestionBox";
import RadioButton from "../../ui/RadioButton/RadioButton";
import classes from "../Infrastructure/Infrastructure.module.css";
import CommonFooter from "../../CommonFooter/CommonFooter";
import CommonButton from "../../ui/CommonButton/CommonButton";
import { useAuth } from "../../../context/AuthContext";
import { useParams } from "react-router-dom";
import { useQuestionnaire } from "../../../hooks/useQuestionnaire";

const initialState = {
  biosafetyLevel: "",
  biosafetyCabinetClass: "",
  biosafetyCabinetCount: "",
  isBiosafetyCabinetCertified: "",
  lastCabinetCertificationDate: "",
  hasBiosafetyOfficer: "",
  biosafetyOfficerName: "",
  officerTrained: "",
  hasControlledAccess: "",
  hasFireExtinguishers: "",
  fireExtinguishingMechanisms: ["", ""],
  hasSpillKits: "",
};

const Biosafety = () => {

    const {
    formData,
    handleChange,
    handleDone,
    editMode,
    setEditMode,
    isReadOnly,
    isFetching,
    loading,
    isOffline
  } = useQuestionnaire("biosafety", initialState);

  const [currentSet, setCurrentSet] = useState(0);

  const { user } = useAuth();
  const { labId: paramLabId } = useParams();
  const labId = paramLabId || user?.labId;
  const userRole = user?.role;

  
  // --------------------------
  // UI QUESTION SETS
  // --------------------------
  const questionSets = [
    {
      content: (
        <div className="d-flex flex-column gap-4">
          <QuestionBox
            number={1}
            question="What is the Biosafety Level of the Laboratory?"
            multilineInput
            value={formData.biosafetyLevel}
            onChange={(e) => handleChange("biosafetyLevel", e.target.value)}
            disabled={isReadOnly}
          />

          <QuestionBox
            number={2}
            question="What is the Class of Biosafety Cabinet in use?"
            multilineInput
            value={formData.biosafetyCabinetClass}
            onChange={(e) =>
              handleChange("biosafetyCabinetClass", e.target.value)
            }
            disabled={isReadOnly}
          />

          <QuestionBox
            number={3}
            question="How many Biosafety Cabinet available?"
            disabled={isReadOnly}
          >
            <div
              className={`${classes.customInput}  d-flex align-items-center`}
            >
              <input
                type="text"
                placeholder="Enter number"
                onChange={(e) =>
                  handleChange("biosafetyCabinetCount", e.target.value)
                }
                value={formData.biosafetyCabinetCount}
              />
            </div>
          </QuestionBox>

          <QuestionBox
            number={4}
            question="Is/Are the Biosafety Cabinet(s) Certified?"
            disabled={isReadOnly}
          >
            <div className="d-flex gap-2 mb-2">
              <RadioButton
                label="Yes"
                checked={formData.isBiosafetyCabinetCertified === "Yes"}
                onChange={() =>
                  handleChange("isBiosafetyCabinetCertified", "Yes")
                }
                disabled={isReadOnly}
              />
              <RadioButton
                label="No"
                checked={formData.isBiosafetyCabinetCertified === "No"}
                onChange={() =>
                  handleChange("isBiosafetyCabinetCertified", "No")
                }
                disabled={isReadOnly}
              />
            </div>
          </QuestionBox>

          <QuestionBox
            number={5}
            question="When was the last Biosafety Cabinet Certification?"
            disabled={isReadOnly}
          >
            <div className={`${classes.customInput} d-flex align-items-center`}>
              <input
                type="text"
                placeholder="Enter date"
                onChange={(e) =>
                  handleChange("lastCabinetCertificationDate", e.target.value)
                }
                value={formData.lastCabinetCertificationDate}
                disabled={isReadOnly}
              />
            </div>
          </QuestionBox>

          <QuestionBox
            number={6}
            question="Does the Laboratory have a Biosafety Officer?"
            disabled={isReadOnly}
          >
            <div className="d-flex gap-2 mb-2">
              <RadioButton
                label="Yes"
                checked={formData.hasBiosafetyOfficer === "Yes"}
                onChange={() => handleChange("hasBiosafetyOfficer", "Yes")}
                disabled={isReadOnly}
              />
              <RadioButton
                label="No"
                checked={formData.hasBiosafetyOfficer === "No"}
                onChange={() => handleChange("hasBiosafetyOfficer", "No")}
                disabled={isReadOnly}
              />
            </div>
          </QuestionBox>

          <QuestionBox
            number={7}
            question="Has the Biosafety Officer undergone Biosafety Training?"
            disabled={isReadOnly}
          >
            <div className="d-flex gap-2 mb-2">
              <RadioButton
                label="Yes"
                checked={formData.officerTrained === "Yes"}
                onChange={() => handleChange("officerTrained", "Yes")}
                disabled={isReadOnly}
              />
              <RadioButton
                label="No"
                checked={formData.officerTrained === "No"}
                onChange={() => handleChange("officerTrained", "No")}
                disabled={isReadOnly}
              />
            </div>
          </QuestionBox>

          <QuestionBox
            number={8}
            question="Name of the Biosafety Officer?"
            disabled={isReadOnly}
          >
            <div className={`${classes.customInput} d-flex align-items-center`}>
              <input
                type="text"
                placeholder="Enter name"
                onChange={(e) =>
                  handleChange("biosafetyOfficerName", e.target.value)
                }
                value={formData.biosafetyOfficerName}
                disabled={isReadOnly}
              />
            </div>
          </QuestionBox>

          <QuestionBox
            number={9}
            question="Does the Laboratory have a controlled Access?"
            disabled={isReadOnly}
          >
            <div className="d-flex gap-2 mb-2">
              <RadioButton
                label="Yes"
                checked={formData.hasControlledAccess === "Yes"}
                onChange={() => handleChange("hasControlledAccess", "Yes")}
                disabled={isReadOnly}
              />
              <RadioButton
                label="No"
                checked={formData.hasControlledAccess === "No"}
                onChange={() => handleChange("hasControlledAccess", "No")}
                disabled={isReadOnly}
              />
            </div>
          </QuestionBox>

          <QuestionBox
            number={10}
            question="Does the Laboratory have fire extinguishers?"
            disabled={isReadOnly}
          >
            <div className="d-flex gap-2 mb-2">
              <RadioButton
                label="Yes"
                checked={formData.hasFireExtinguishers === "Yes"}
                onChange={() => handleChange("hasFireExtinguishers", "Yes")}
                disabled={isReadOnly}
              />
              <RadioButton
                label="No"
                checked={formData.hasFireExtinguishers === "No"}
                onChange={() => handleChange("hasFireExtinguishers", "No")}
                disabled={isReadOnly}
              />
            </div>
          </QuestionBox>

          <QuestionBox
            number={11}
            question="List any mechanisms the Laboratory has put in place to extinguish fires?"
            singleInput
            answers={formData.fireExtinguishingMechanisms}
            onAnswersChange={(newAnswers) =>
              handleChange("fireExtinguishingMechanisms", newAnswers)
            }
            disabled={isReadOnly}
          />

          <QuestionBox
            number={12}
            question="Does the Laboratory have any spill kits for spillage control?"
            disabled={isReadOnly}
          >
            <div className="d-flex gap-2 mb-2">
              <RadioButton
                label="Yes"
                checked={formData.hasSpillKits === "Yes"}
                onChange={() => handleChange("hasSpillKits", "Yes")}
                disabled={isReadOnly}
              />
              <RadioButton
                label="No"
                checked={formData.hasSpillKits === "No"}
                onChange={() => handleChange("hasSpillKits", "No")}
                disabled={isReadOnly}
              />
            </div>
          </QuestionBox>
        </div>
      ),
    },
  ];

  if (isFetching) return <div className={classes.loading}>Loading...</div>;

  return (
    <div
      className={`${classes.wrapper} ${paramLabId ? classes.fromParams : ""} ${
        isReadOnly ? classes.readOnly : ""
      }`}
    >
      <div className="d-flex justify-content-between align-items-center">
        <h2>Biosafety and Biosecurity</h2>

        {userRole === "LABORATORY" && !editMode && (
          <CommonButton
            className={classes.editButton}
            title="Edit"
            onClick={() => setEditMode(true)}
          />
        )}
      </div>

      {!editMode && userRole !== "MINISTRY" ? (
        <div className={classes.infoText}>
          ✅ Your biosafety and biosecurity has been submitted.
        </div>
      ) : (
        questionSets[currentSet].content
      )}

      {editMode && (
        <CommonFooter
          handlePrevious={() =>
            currentSet > 0 && setCurrentSet((prev) => prev - 1)
          }
          handleNext={() =>
            currentSet < questionSets.length - 1 &&
            setCurrentSet((prev) => prev + 1)
          }
          handleDone={handleDone}
          cancelText="Cancel"
          handleCancel={() => {
            setEditMode(false);
            setCurrentSet(0);
          }}
          questionSets={questionSets}
          currentSet={currentSet}
          doneText={
            loading ? "Submitting..." : isOffline ? "Save Offline" : "Submit"
          }
        />
      )}
    </div>
  );
};

export default Biosafety;
